import { computed, inject, Injectable } from '@angular/core';
import { AppUsersRepository } from '@repositories';
import { AuthState, UserState } from 'moddy/common';
import { filter, skip, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppUserService {
    public readonly id = computed(() => this.userState.id());
    public readonly data = computed(() => this.userState.value());

    private readonly userState = inject(UserState);
    private readonly authState = inject(AuthState);
    private readonly appUsersRepository = inject(AppUsersRepository);

    private userSubscription?: Subscription;

    public async update(): Promise<void> {
        const id = this.authState.value()?.uid;

        if (id) {
            const dbDocument = await this.appUsersRepository.get(id);

            this.userState.set(dbDocument);
        } else {
            this.userState.set(null);
        }
    }

    public initObserver(): void {
        const id = this.authState.value()?.uid;

        this.userSubscription?.unsubscribe();

        if (id) {
            this.userSubscription = this.appUsersRepository
                .observe(id)
                .pipe(
                    skip(1),
                    filter(() => !!this.authState.value())
                )
                .subscribe((data) => this.userState.set(data));
        } else {
            this.userState.set(null);
        }
    }
}
